import Model, { attr } from '@ember-data/model';

export default class AuditMetadatum extends Model {
  @attr('string') name;
  @attr('string') type;
  @attr('string') metaObjectId;
}
